//default from angular libraries
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

//import constants
import { AppPermissions } from '../constants/app-permission';

//import services
import { AuthService } from './../services/auth.service';


@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private ngxPermissionsService: NgxPermissionsService,
    private ngxRolesService: NgxRolesService,
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if(this.authService.isLoggedIn())
    {
      
      return new Promise(
        (resolve, reject) => {

              this.authService.permission().subscribe(
                (res : any) => {
                  console.log("=========== Data =========")
                  console.log(res)
                  var load_perm = res.data.permission;
                  const perm = [AppPermissions.LOGGED_IN];
                  this.ngxPermissionsService.loadPermissions(perm);

                  if(res.data.sub_user == 1)
                    this.ngxPermissionsService.addPermission('subUser');
                  else
                    this.ngxPermissionsService.addPermission('parentUser');

                  Object.keys(load_perm).forEach(key => {
                    // console.log(load_perm[key]);
                    // console.log(AppPermissions.WRITE);
                      if(load_perm[key] == AppPermissions.WRITE)
                      {
                        this.ngxPermissionsService.addPermission(key);
                        this.ngxRolesService.addRole(key, load_perm[key]);
                      }
                      else if(load_perm[key] == AppPermissions.READ)
                      {
                        this.ngxPermissionsService.addPermission(key);
                        this.ngxRolesService.addRole(key, load_perm[key]);
                      }
                  });

                  // var permissions = this.ngxPermissionsService.getPermissions();
 
                  // this.ngxPermissionsService.permissions$.subscribe((permissions) => {
                  //     console.log(permissions)
                  // })
                  // console.log(load_perm)


                  resolve(true);
                },
                err => {
                  // const perm = [AppPermissions.NOT_LOGGED_IN];
                  const perm = [AppPermissions.LOGGED_IN];
                  this.ngxPermissionsService.loadPermissions(perm);  
                  resolve(true);
                }
              );
        }
      );
    }
    else
    {
        const perm = [AppPermissions.NOT_LOGGED_IN];
        this.ngxPermissionsService.loadPermissions(perm);  
        return true;
    }
    
  }

  parse_permission(perm)
  {
    var arr = [];

    Object.keys(perm).forEach(key=> {
        var value = perm[key];
        if(value == 2)
          arr[key] = ['write', 'read'];
        else if(value == 1)
          arr[key] = ['read'];
    });

    return arr;

  }

}


